// components/AccordionFAQ.tsx

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  id: string | number;
  Question: string;
  Answer: string;
}

interface AccordionFAQProps {
  heading: string;
  faqs: FAQItem[];
  maxCount?: number;
}

const AccordionFAQ: React.FC<AccordionFAQProps> = ({ heading, faqs, maxCount }) => {
  const [openFaqs, setOpenFaqs] = useState<Record<number, boolean>>({});

  const toggleFaq = (index: number) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const faqsToShow = maxCount ? faqs?.slice(0, maxCount) : faqs;

  return (
    <section className="mt-6 rounded-lg bg-white p-4 shadow-lg lg:p-6">
      <h2 className="text-base font-bold md:text-xl">{heading}</h2>
      <div className="mt-5 flex flex-col">
        {faqsToShow?.length > 0 ? (
          faqsToShow?.map((faq, index) => (
            <div key={faq.id} className="my-2 border-b border-b-gray-300 pb-4 font-inter">
              <button
                type="button"
                className="flex w-full items-center justify-between gap-x-1.5 text-left text-base"
                onClick={() => toggleFaq(index)}
              >
                <div className="text-sm font-semibold md:text-base">
                  <span className="mr-2 inline-block text-primary-text">{index + 1}.</span>
                  {faq.Question}
                </div>
                <ChevronDown
                  className={`text-gray-600 duration-200 sm:text-lg ${openFaqs[index] ? '' : '-rotate-90'}`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openFaqs[index] ? 'max-h-60' : 'max-h-0'}`}
              >
                <p className="my-2 ml-6 cursor-default text-xs font-medium leading-normal tracking-wide text-primary-gray md:text-sm">
                  {faq.Answer}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p>No FAQs available for this category.</p>
        )}
      </div>
    </section>
  );
};

export default AccordionFAQ;
